import { FC } from 'react';
import { Typography } from '@mui/material';

import styles from './RadioOption.module.scss';

const RadioOption: FC<{ value: string; label: string; icon: string; selected: boolean }> = ({ value, label, icon, selected }) => (
  <div className={`${styles.radioOption} ${selected ? styles.selected : ""}`}>
    <img src={icon} alt={label} />
    {selected ? (
      <Typography variant='h9Semibold' className={styles.label}>{label}</Typography>
    ) : (
      <Typography variant='h9' className={styles.label}>{label}</Typography>
    )}
  </div>
);

export default RadioOption;
